import axios from 'axios';

import migrateAuthTokenIfNeeded from 'mf-shared/utils/interceptors/migrateAuthTokenIfNeeded';
import refreshSessionIfExpired from 'mf-shared/utils/interceptors/refreshSessionIfExpired';
import addAuthorizationHeaderIfNotExists from 'mf-shared/utils/interceptors/addAuthorizationHeaderIfNotExists';
import redirectLegacyApis from 'mf-shared/utils/interceptors/redirectLegacyApis';
import axiosCacheInstance from 'mf-shared/utils/axiosCache';

/*
 * Setup interceptors
 */

axios.interceptors.request.use(addAuthorizationHeaderIfNotExists);
axios.interceptors.request.use(refreshSessionIfExpired);
axios.interceptors.request.use(migrateAuthTokenIfNeeded);
axios.interceptors.request.use(redirectLegacyApis);
axios.defaults.adapter = axiosCacheInstance.adapter;
